import type { Risonanza } from './risonanze';

export interface MoveDef {
  id: string;
  name: string;
  risonanza: Risonanza;
  power: number;
  accuracy: number; // 0..1
  description: string;
}

const defs: MoveDef[] = [
  // Aurora
  {
    id: 'lampo-prismatico',
    name: 'Lampo Prismatico',
    risonanza: 'aurora',
    power: 40,
    accuracy: 1,
    description: 'Un fascio di luce rifratta che abbaglia il bersaglio.',
  },
  {
    id: 'velo-boreale',
    name: 'Velo Boreale',
    risonanza: 'aurora',
    power: 65,
    accuracy: 0.9,
    description: 'Avvolge il nemico in nastri di aurora gelida.',
  },
  // Brace
  {
    id: 'soffio-di-cenere',
    name: 'Soffio di Cenere',
    risonanza: 'brace',
    power: 40,
    accuracy: 1,
    description: 'Una nube di braci sottili che brucia al contatto.',
  },
  {
    id: 'cuore-di-magma',
    name: 'Cuore di Magma',
    risonanza: 'brace',
    power: 70,
    accuracy: 0.85,
    description: 'Concentra il calore della faglia in un colpo rovente.',
  },
  // Marea
  {
    id: 'stilla-lucente',
    name: 'Stilla Lucente',
    risonanza: 'marea',
    power: 40,
    accuracy: 1,
    description: 'Gocce luminescenti scagliate ad alta pressione.',
  },
  {
    id: 'onda-cristallina',
    name: 'Onda Cristallina',
    risonanza: 'marea',
    power: 65,
    accuracy: 0.9,
    description: "Un'onda che cristallizza brevemente ciò che tocca.",
  },
  // Terra
  {
    id: 'scaglia-di-quarzo',
    name: 'Scaglia di Quarzo',
    risonanza: 'terra',
    power: 45,
    accuracy: 0.95,
    description: 'Frammenti di quarzo magnetizzato lanciati a raffica.',
  },
  {
    id: 'eruzione-silicea',
    name: 'Eruzione Silicea',
    risonanza: 'terra',
    power: 70,
    accuracy: 0.85,
    description: 'Il terreno erutta colonne di sabbia vetrificata.',
  },
  // Volt
  {
    id: 'scintilla-vagante',
    name: 'Scintilla Vagante',
    risonanza: 'volt',
    power: 40,
    accuracy: 1,
    description: 'Una scarica che insegue il bersaglio.',
  },
  {
    id: 'arco-di-faglia',
    name: 'Arco di Faglia',
    risonanza: 'volt',
    power: 70,
    accuracy: 0.85,
    description: "Un arco voltaico attinto dall'anomalia più vicina.",
  },
  // Eco
  {
    id: 'pulsazione',
    name: 'Pulsazione',
    risonanza: 'eco',
    power: 40,
    accuracy: 1,
    description: "Un'onda sonora che fa vibrare le membrane del nemico.",
  },
  {
    id: 'canto-della-cava',
    name: 'Canto della Cava',
    risonanza: 'eco',
    power: 65,
    accuracy: 0.9,
    description: 'Un richiamo profondo che risuona nelle ossa.',
  },
  // Neutre/di copertura
  {
    id: 'zampata',
    name: 'Zampata',
    risonanza: 'terra',
    power: 35,
    accuracy: 1,
    description: 'Un colpo semplice ma affidabile.',
  },
  {
    id: 'sciame-lucente',
    name: 'Sciame Lucente',
    risonanza: 'aurora',
    power: 50,
    accuracy: 0.95,
    description: 'Particelle bioluminescenti che sciamano sul bersaglio.',
  },
];

export const MOVES: ReadonlyMap<string, MoveDef> = new Map(defs.map((m) => [m.id, m]));

export function getMove(id: string): MoveDef {
  const move = MOVES.get(id);
  if (!move) throw new Error(`Mossa sconosciuta: ${id}`);
  return move;
}
